import styles from './index.module.scss'
import loader from '../../../assets/images/loading.svg'


const Loading = ()=>{
   return(
      <section className={`${styles.container}`}>
         <img src={loader} alt="Loading..." />
      </section>
   )
}

export default Loading